import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSmartphone, FiRefreshCw } = FiIcons;

export default function Step2Choice({ onSelect, amount }) {
  return (
    <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-slate-900 mb-2">How would you like to clear ${amount}?</h2>
        <p className="text-slate-600">Choose the path that works best for you.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          onClick={() => onSelect('keep')}
          className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-blue-600 hover:shadow-lg transition-all cursor-pointer group flex flex-col items-center text-center"
        >
          <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
            <SafeIcon icon={FiSmartphone} className="w-8 h-8 text-blue-600 group-hover:text-white" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-3">Keep My Phone</h3>
          <p className="text-slate-600 mb-6">
            We finance your carrier payoff. You keep your device and repay us over time with a plan that fits your budget.
          </p>
          <span className="mt-auto text-blue-600 font-semibold group-hover:underline">Select Option →</span>
        </div>

        <div
          onClick={() => onSelect('trade')}
          className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-indigo-600 hover:shadow-lg transition-all cursor-pointer group flex flex-col items-center text-center"
        >
          <div className="w-16 h-16 bg-indigo-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-indigo-600 transition-colors">
            <SafeIcon icon={FiRefreshCw} className="w-8 h-8 text-indigo-600 group-hover:text-white" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-3">Trade It In</h3>
          <p className="text-slate-600 mb-6">
            Trade in your current device to offset or clear your remaining balance. We handle the logistics and pay your carrier directly.
          </p>
          <span className="mt-auto text-indigo-600 font-semibold group-hover:underline">Select Option →</span>
        </div>
      </div>
    </motion.div>
  );
}